import script from "./SlicerDimensao.vue?vue&type=script&setup=true&lang=js"
export * from "./SlicerDimensao.vue?vue&type=script&setup=true&lang=js"

import "./SlicerDimensao.vue?vue&type=style&index=0&id=6617a3aa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6617a3aa"]])

export default __exports__